function view (path) {
  return () => import(/* webpackChunkName: 'po-v1' */ '@/views/po/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

function viewPurchaseOrders (path) {
  return view('purchase-orders/' + path)
}

// function viewInterBranches (path) {
//   return view('inter-branches/' + path)
// }

// function viewInterWarehouses (path) {
//   return view('inter-warehouses/' + path)
// }

const RPurchasingOfficer = [
  {
    path: '/purchase-officer/dashboard',
    component: view('Dashboard'),
    name: 'po.dashboard',
    authorizedRole: 'user'
  }
]

const RPOPurchaseOrders = [
  {
    path: '/purchase-officer/purchase-orders/requests/:requester?/:status?',
    component: viewPurchaseOrders('requests/Base'),
    name: 'po.purchase-orders.requests',
    authorizedRole: 'user',
    meta: {
      breadcrumb: [
        {
          text: 'Purchase Officer'
        },
        {
          text: 'Purchase Orders'
        },
        {
          text: 'Requests',
          active: true
        }
      ]
    }
  },
  {
    path: '/purchase-officer/purchase-orders/receiving/:receiver?/:status?',
    component: viewPurchaseOrders('receiving/Base'),
    name: 'po.purchase-orders.receiving',
    authorizedRole: 'user',
    meta: {
      breadcrumb: [
        {
          text: 'Purchase Officer'
        },
        {
          text: 'Purchase Orders'
        },
        {
          text: 'Receiving',
          active: true
        }
      ]
    }
  }
]

const RPOInterBranches = [
  // {
  //   path: '/purchase-officer/inter-branches/transfers/:transfer?/:status?',
  //   component: viewInterBranches('transfers/Base'),
  //   name: 'po.inter-branches.transfers',
  //   authorizedRole: 'user',
  //   meta: {
  //     breadcrumb: [
  //       {
  //         text: 'Purchase Officer'
  //       },
  //       {
  //         text: 'Inter Branches'
  //       },
  //       {
  //         text: 'Transfers',
  //         active: true
  //       }
  //     ]
  //   }
  // },
  // {
  //   path: '/purchase-officer/inter-branches/posting/:poster?/:status?',
  //   component: viewInterBranches('posting/Base'),
  //   name: 'po.inter-branches.posting',
  //   authorizedRole: 'user',
  //   meta: {
  //     breadcrumb: [
  //       {
  //         text: 'Purchase Officer'
  //       },
  //       {
  //         text: 'Inter Branches'
  //       },
  //       {
  //         text: 'Posting',
  //         active: true
  //       }
  //     ]
  //   }
  // },
  // {
  //   path: '/purchase-officer/inter-branches/receiving/:receiver?/:status?',
  //   component: viewInterBranches('receiving/Base'),
  //   name: 'po.inter-branches.receiving',
  //   authorizedRole: 'user',
  //   meta: {
  //     breadcrumb: [
  //       {
  //         text: 'Purchase Officer'
  //       },
  //       {
  //         text: 'Inter Branches'
  //       },
  //       {
  //         text: 'Receiving',
  //         active: true
  //       }
  //     ]
  //   }
  // }
]

const RPOInterWarehouses = [
  // {
  //   path: '/purchase-officer/inter-warehouses/transfers/:transfer?/:status?',
  //   component: viewInterWarehouses('transfers/Base'),
  //   name: 'po.inter-warehouses.transfers',
  //   authorizedRole: 'user',
  //   meta: {
  //     breadcrumb: [
  //       {
  //         text: 'Warehouse'
  //       },
  //       {
  //         text: 'Inter Warehouses'
  //       },
  //       {
  //         text: 'Transfers',
  //         active: true
  //       }
  //     ]
  //   }
  // },
  // {
  //   path: '/purchase-officer/inter-warehouses/posting/:poster?/:status?',
  //   component: viewInterWarehouses('posting/Base'),
  //   name: 'po.inter-warehouses.posting',
  //   authorizedRole: 'user',
  //   meta: {
  //     breadcrumb: [
  //       {
  //         text: 'Warehouse'
  //       },
  //       {
  //         text: 'Inter Warehouses'
  //       },
  //       {
  //         text: 'Posting',
  //         active: true
  //       }
  //     ]
  //   }
  // },
  // {
  //   path: '/purchase-officer/inter-warehouses/receiving/:receiver?/:status?',
  //   component: viewInterWarehouses('receiving/Base'),
  //   name: 'po.inter-warehouses.receiving',
  //   authorizedRole: 'user',
  //   meta: {
  //     breadcrumb: [
  //       {
  //         text: 'Warehouse'
  //       },
  //       {
  //         text: 'Inter Warehouses'
  //       },
  //       {
  //         text: 'Receiving',
  //         active: true
  //       }
  //     ]
  //   }
  // }
]

export default RPurchasingOfficer.concat(
  RPOPurchaseOrders,
  RPOInterBranches,
  RPOInterWarehouses
)
